import type { ForwardedRef } from 'react';
import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import Avatar from '../components/Avatar';
import Badge from '../components/Badge';
import BorderedIcon from '../components/BorderedIcon';
import SelectEntityOption from '../components/SelectEntityOption';
import emailIcon from '../icons/non-prefilled/16x16/email.svg';
import type { InvitationUserSelectOptionType } from './InvitationUserSelect';
import styles from './InvitationUserSelectOption.module.scss';

export enum ExternalUserState {
  Invited = 'INVITED',
  Deactivated = 'DEACTIVATED',
  Teammate = 'TEAMMATE',
  Uninvited = 'UNINVITED',
}

type InvitationUserSelectOptionProps = OptionProps<
  InvitationUserSelectOptionType,
  true
> & { isDisabled: boolean };

const InvitationUserSelectOption = (
  props: InvitationUserSelectOptionProps,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const { data, isDisabled } = props;

  return (
    <components.Option {...props}>
      <SelectEntityOption
        {...props}
        ref={ref}
        icon={
          !data.__isNew__ ? (
            <Avatar
              user={{
                name: data.label,
                avatar: data.avatar,
              }}
            />
          ) : (
            <BorderedIcon>{emailIcon}</BorderedIcon>
          )
        }
        label={
          <>
            {data.label}
            {data.state !== ExternalUserState.Uninvited && (
              <span className={styles.badgeContainer}>
                {data.state === ExternalUserState.Invited && (
                  <Badge color="gray">Invited</Badge>
                )}
                {data.state === ExternalUserState.Teammate && (
                  <Badge color="green">Teammate</Badge>
                )}
                {data.state === ExternalUserState.Deactivated && (
                  <Badge color="gray">Deactivated</Badge>
                )}
              </span>
            )}
          </>
        }
        secondary={!data.__isNew__ && data.value}
        disabled={isDisabled}
      />
    </components.Option>
  );
};

export default React.forwardRef<
  HTMLDivElement,
  InvitationUserSelectOptionProps
>(InvitationUserSelectOption);
